import { createGlobalStyle, styled } from '@nx-kit/styling';
import Icon from 'components/atoms/Icon/Icon';

export const ButtonStyled = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  height: 45px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.global.color.gray650};
  color: ${(props) => props.theme.global.color.gray900};
  background-color: ${(props) => props.theme.global.color.white};
  font-size: 14px;
  font-weight: 500;
  min-width: 136px;
  width: 100%;

  .datepicker-label {
    flex: 1;
    text-align: left;
    padding-left: 0;
  }
`;

export const IconStyled = styled(Icon)`
  width: 28px;
  height: 28px;
  color: ${(props) => props.theme.global.color.primary};
  margin-left: auto;
  flex-shrink: 0;
`;

export const DatePickerGlobalStyle = createGlobalStyle`
  .datepicker-popper{
    z-index:${(props) => props.theme.global.zIndex.datePicker};
  }

  .ballenberg-datepicker {
    width: 100%;
  }

  .ballenberg-datepicker__popper {
    z-index: ${(props) => props.theme.global.zIndex.datePicker};
  }

  .ballenberg-datepicker .react-datepicker__input-container input {
    width: 100%;
    height: 45px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.global.color.gray650};
    padding: 0 14px;
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.global.color.gray900};
    background-color: ${(props) => props.theme.global.color.white};
    transition: border-color 200ms ease, box-shadow 200ms ease;
  }

  .ballenberg-datepicker .react-datepicker__input-container input::placeholder {
    color: ${(props) => props.theme.global.color.gray180};
  }

  .ballenberg-datepicker .react-datepicker__input-container input:focus {
    outline: none;
    border-color: ${(props) => props.theme.global.color.primary};
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);
  }

  .ballenberg-datepicker__calendar.react-datepicker {
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme.global.color.gray50};
    background: ${(props) => props.theme.global.color.white};
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
    padding: 8px 10px 10px;
    color: ${(props) => props.theme.global.color.gray900};
  }

  .ballenberg-datepicker__calendar .react-datepicker__header {
    background: ${(props) => props.theme.global.color.white};
    border-bottom: 1px solid ${(props) => props.theme.global.color.gray50};
    padding: 8px 0 6px;
  }

  .ballenberg-datepicker__calendar .react-datepicker__current-month {
    font-weight: 600;
    font-size: 14px;
    color: ${(props) => props.theme.global.color.gray900};
  }

  .ballenberg-datepicker__calendar .react-datepicker__day-names {
    margin-top: 6px;
  }

  .ballenberg-datepicker__calendar .react-datepicker__day-name {
    color: ${(props) => props.theme.global.color.gray180};
    font-size: 12px;
    font-weight: 500;
    margin: 0 2px;
  }

  .ballenberg-datepicker__calendar .react-datepicker__day {
    width: 34px;
    line-height: 32px;
    margin: 2px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: ${(props) => props.theme.global.color.gray900};
  }

  .ballenberg-datepicker__calendar .react-datepicker__day:hover {
    background: ${(props) => props.theme.global.color.gray50};
    color: ${(props) => props.theme.global.color.primary};
  }

  .ballenberg-datepicker__calendar .react-datepicker__day--selected,
  .ballenberg-datepicker__calendar .react-datepicker__day--keyboard-selected {
    background: ${(props) => props.theme.global.color.primary};
    color: ${(props) => props.theme.global.color.white};
  }

  .ballenberg-datepicker__calendar .react-datepicker__day--today {
    border: 1px solid ${(props) => props.theme.global.color.primary};
  }

  .ballenberg-datepicker__calendar .react-datepicker__navigation {
    top: 10px;
  }

  .ballenberg-datepicker__calendar .react-datepicker__navigation-icon::before {
    border-color: ${(props) => props.theme.global.color.gray900};
  }
`;
